import { createRouter, createWebHistory } from "vue-router";

// 引入视图组件
import UserLogin from "../views/UserLogin.vue";
import UserRegister from "../views/UserRegister.vue";
import UserDashboard from "../views/UserDashboard.vue";
import PlanList from "../views/PlanList.vue";
import PlanCalendar from "../views/PlanCalendar.vue";
import InitialSetup from "../views/InitialSetup.vue";
import StepOne from "@/components/setup/StepOne.vue";
// import StepTwo from "@/components/setup/StepTwo.vue";
// import CategorySetup from "@/components/category/CategorySetup.vue";
import "@vuepic/vue-datepicker/dist/main.css";
import AuthCallback from "../views/AuthCallback.vue";

// 布局组件
import DefaultLayout from "@/layouts/DefaultLayout.vue"; // 假设这是您的默认布局组件
import EmptyLayout from "@/layouts/EmptyLayout.vue"; // 假设这是您的空布局组件
// 定义路由
const routes = [
  {
    path: "/auth/callback",
    name: "AuthCallback",
    component: AuthCallback,
  },
  {
    path: "/",
    component: UserDashboard,
    meta: { layout: "DefaultLayout", className: "dashboard-page" },
  },

  {
    path: "/login",
    component: UserLogin,
    meta: { layout: "EmptyLayout", className: "login-page" },
  },
  {
    path: "/register",
    component: UserRegister,
    meta: { layout: "EmptyLayout", className: "register-page" },
  },
  {
    path: "/plan",
    name: "PlanList",
    component: PlanList,
    meta: { layout: DefaultLayout },
  },
  {
    path: "/calendar",
    component: PlanCalendar,
    meta: { layout: DefaultLayout },
  },
  {
    path: "/initial-setup",
    component: InitialSetup,
    meta: { layout: EmptyLayout }, // 这里假设 InitialSetup 页面不需要侧边栏
    children: [
      { path: "step-one", component: StepOne },
      // { path: "step-two", component: StepTwo },
      // { path: "category-setup", component: CategorySetup },
    ],
  },
];

// 创建路由器实例
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

// 添加全局前置守卫
router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!localStorage.getItem("isLoggedIn")) {
      next({ path: "/login" });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
